import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import { appConfig } from "src/config";

import { ExportTaskCard, NewExportTaskCard } from "./components";
import { MAX_EXPORT_TASKS } from "./ExportPage.constants";
import css from "./ExportPage.module.scss";
import { getExportTasksRequest } from "./store/fetchers";

export const ExportPage = () => {
  const getExportTasks = useAction(getExportTasksRequest);
  const [tasks] = useAtom(getExportTasksRequest.dataAtom);
  const [isLoadingTasks] = useAtom(getExportTasksRequest.isLoadingAtom);

  const hasExportTasksSpace = tasks.data.length < MAX_EXPORT_TASKS;

  useEffect(() => {
    getExportTasks();
  }, [getExportTasks]);

  const isLoading = isLoadingTasks && tasks.data.length <= 0;

  return (
    <>
      <Helmet>
        <title>{appConfig.displayName} · Консоль · Выгрузка</title>
      </Helmet>
      <div className={css.title}>Выгрузки</div>

      <div className={css.grid}>
        {hasExportTasksSpace && <NewExportTaskCard />}
        {tasks.data?.map((task) => (
          <ExportTaskCard key={task.id} task={task} />
        ))}

        {isLoading && (
          <Skeleton
            width={"100%"}
            height={"72px"}
            baseColor="var(--g-color-base-generic)"
            highlightColor="var(--g-color-base-simple-hover)"
          />
        )}
      </div>
    </>
  );
};
